var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.titulo } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isVerDetalle,
                                  expression: "!isVerDetalle"
                                }
                              ],
                              attrs: { row: "", wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      label: _vm.formFields.estado.label,
                                      id: _vm.formFields.estado.id,
                                      color: "yellow",
                                      readonly: _vm.isVerDetalle,
                                      hint: _vm.hint,
                                      "persistent-hint": true
                                    },
                                    on: { change: _vm.cambio },
                                    model: {
                                      value: _vm.estado,
                                      callback: function($$v) {
                                        _vm.estado = $$v
                                      },
                                      expression: "estado"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.nombre.label,
                                      "data-vv-name": _vm.formFields.nombre.id,
                                      id: "txtNombre",
                                      disabled: _vm.isVerDetalle,
                                      readonly: _vm.esEditar,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.nombre.id
                                      )
                                    },
                                    model: {
                                      value: _vm.formFields.nombre.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.nombre,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.nombre.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x12: "", sm12: "", md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.zona.label,
                                      items: _vm.lsZonas,
                                      "item-value": "id",
                                      "item-text": "nombre",
                                      required: "",
                                      "error-messages": _vm.errors.collect(
                                        "lsZonas"
                                      ),
                                      "data-vv-name": "lsZonas",
                                      "no-data-text": "Sin resultados",
                                      disabled: _vm.isVerDetalle,
                                      autocomplete: ""
                                    },
                                    model: {
                                      value: _vm.formFields.zona.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.zona,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.zona.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x12: "", sm12: "", md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.color.label,
                                      items: _vm.lsColor,
                                      "item-value": "colorhexadecimal",
                                      "item-text": "color",
                                      required: "",
                                      "error-messages": _vm.errors.collect(
                                        "Colores"
                                      ),
                                      "no-data-text": "Sin resultados",
                                      "data-vv-name": "Colores",
                                      disabled: _vm.isVerDetalle,
                                      autocomplete: ""
                                    },
                                    model: {
                                      value: _vm.formFields.color.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.color,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.color.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "numeric|max_value:200|min_value:0|integer",
                                        expression:
                                          "'numeric|max_value:200|min_value:0|integer'"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      label: _vm.formFields.vminima.label,
                                      "data-vv-name": _vm.formFields.vminima.id,
                                      id: _vm.formFields.vminima.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.vminima.id
                                      )
                                    },
                                    model: {
                                      value: _vm.formFields.vminima.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.vminima,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.vminima.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "numeric|max_value:200|min_value:0|integer",
                                        expression:
                                          "'numeric|max_value:200|min_value:0|integer'"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      label: _vm.formFields.vmaxima.label,
                                      "data-vv-name": _vm.formFields.vmaxima.id,
                                      id: _vm.formFields.vmaxima.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.vmaxima.id
                                      )
                                    },
                                    model: {
                                      value: _vm.formFields.vmaxima.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.vmaxima,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.vmaxima.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields.permiteDetencion.label,
                                      "data-vv-name":
                                        _vm.formFields.permiteDetencion.id,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.permiteDetencion.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.permiteDetencion,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.permiteDetencion.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required: _vm.isValidateTP
                                          }
                                        },
                                        expression:
                                          "{\n                    rules: {\n                      required: isValidateTP,\n                    },\n                  }"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      label:
                                        _vm.formFields.tiempoPernencia.label,
                                      "data-vv-name":
                                        _vm.formFields.tiempoPernencia.id,
                                      id: _vm.formFields.tiempoPernencia.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.tiempoPernencia.id
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.tiempoPernencia.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tiempoPernencia,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tiempoPernencia.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "time",
                                      label: _vm.formFields.horaDesde.label,
                                      "data-vv-name":
                                        _vm.formFields.horaDesde.id,
                                      id: _vm.formFields.horaDesde.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value: _vm.formFields.horaDesde.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.horaDesde,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.horaDesde.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "time",
                                      label: _vm.formFields.horaHasta.label,
                                      "data-vv-name":
                                        _vm.formFields.horaHasta.id,
                                      id: _vm.formFields.horaHasta.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value: _vm.formFields.horaHasta.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.horaHasta,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.horaHasta.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields.RepetirMensaje.label,
                                      "data-vv-name":
                                        _vm.formFields.RepetirMensaje.id,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.RepetirMensaje.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.RepetirMensaje,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.RepetirMensaje.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required: _vm.isValidateRM
                                          }
                                        },
                                        expression:
                                          "{\n                    rules: {\n                      required: isValidateRM,\n                    },\n                  }"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      label:
                                        _vm.formFields.tiempoRepeticionMensaje
                                          .label,
                                      "data-vv-name":
                                        _vm.formFields.tiempoRepeticionMensaje
                                          .id,
                                      id:
                                        _vm.formFields.tiempoRepeticionMensaje
                                          .id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.tiempoRepeticionMensaje
                                          .id
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.tiempoRepeticionMensaje
                                          .value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields
                                            .tiempoRepeticionMensaje,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tiempoRepeticionMensaje.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "numeric|max_value:200|min_value:0|integer",
                                        expression:
                                          "'numeric|max_value:200|min_value:0|integer'"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      label: _vm.formFields.tiempoEntrada.label,
                                      "data-vv-name":
                                        _vm.formFields.tiempoEntrada.id,
                                      id: _vm.formFields.tiempoEntrada.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.tiempoEntrada.id
                                      )
                                    },
                                    model: {
                                      value: _vm.formFields.tiempoEntrada.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tiempoEntrada,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tiempoEntrada.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("v-flex", {
                                attrs: { x4: "", sm4: "", md4: "" }
                              }),
                              _c(
                                "v-flex",
                                { attrs: { x2: "", sm2: "", md2: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { round: "", color: "yellow" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setForm()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("add")]),
                                      _vm._v("\n                  Agregar")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("MantenedorGrid", {
                                attrs: { "grid-options": _vm.gridOptions }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }